import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { StyledButton } from "./Button.styles";
import { ActivityIndicator } from "../ActivityIndicator";
var Button = function(_param) /*#__PURE__*/ {
    var children = _param.children, loading = _param.loading, rest = _object_without_properties(_param, [
        "children",
        "loading"
    ]);
    return _jsxs(StyledButton, _object_spread_props(_object_spread({}, rest), {
        children: [
            loading && /*#__PURE__*/ _jsx(ActivityIndicator, {}),
            children
        ]
    }));
};
var LinkButtonStyle = StyledButton.withComponent("a");
var LinkButton = function(_param) /*#__PURE__*/ {
    var children = _param.children, rest = _object_without_properties(_param, [
        "children"
    ]);
    return _jsx(LinkButtonStyle, _object_spread_props(_object_spread({}, rest), {
        children: children
    }));
};
export { Button, LinkButton };
